import type { FC } from 'react';

type IconProps = {
    className?: string;
};

/**
 * 外部リンクを示すアイコン（↗）
 * 小さなサイズでもはっきり見えるよう、少し太め・大きめにデザイン
 */
export const ExternalLinkIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        {/* フレーム：少し背を高くしつつ、下方向に伸びる印象（右上の角だけ開ける） */}
        <path
            d="M4 6v12h11v-5M9 6H4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        {/* 右上への矢印（さらに少し上寄りに配置） */}
        <path
            d="M12 3h7M19 3v6M19 3L11 11"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);


